import { AxiosError } from 'axios'
import { toast } from 'sonner'

interface ErrorResponse {
  title: string
}

export function handleServerError(error: unknown) {
  console.log(error)

  let errMsg = 'Something went wrong!'

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number(error.status) === 204
  ) {
    errMsg = 'Content not found.'
  }

  if (error instanceof AxiosError) {
    const data = error.response?.data as ErrorResponse | undefined
    if (data?.title) {
      errMsg = data.title
    }
  }

  toast.error(errMsg)
}
